import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const PatientStatusInpatientBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-primary text-primary-foreground">
      {t('component:badge.patientStatusInpatient')}
    </Badge>
  );
};
